import * as cnames from 'classnames'
import * as React from 'react'

import { toTitle } from '../../../../common/utils/formatString'
import Highlighter from '../../../components/highlighter'
import SearchLink from '../../../containers/searchLinkContainer'
import { IItemCard } from '../interface'

import * as styles from './lockupTitleAuthor.module.css'

const formatCategory = (category: string | undefined) =>
  category
    ? category
        .split('/')
        .map(lastLevelCategory => toTitle(lastLevelCategory))
        .pop()
    : ''

interface IProps extends IItemCard {
  inline?: boolean
}

const LockupTitleAuthor = ({
  item,
  onItemLinkClick,
  locationParams,
  rank,
  inline = false
}: IProps) => {
  const { url, name, author_url, author_username } = item
  const { term = '' } = locationParams

  return (
    <div className={cnames(styles.root, { [styles.inline]: inline })}>
      <h3 className={styles.itemName}>
        <a
          href={`${url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
          className={styles.itemNameLink}
          tabIndex={0}
        >
          <Highlighter background keywords={term.split(' ')}>
            {name}
          </Highlighter>
        </a>
      </h3>
      <div className={styles.authorAndCategory}>
        <i> by </i>
        <a className={styles.link} href={author_url.toLowerCase()}>
          {author_username}
        </a>
        <span> in </span>
        <SearchLink
          locationParams={{ category: item.classification }}
          className={styles.link}
        >
          {formatCategory(item.classification)}
        </SearchLink>
      </div>
    </div>
  )
}

export default LockupTitleAuthor
